{% block sw_theme_manager_detail_content_areas %}
	<div v-if="isRhwebTheme && showConfigBoxes" class="rhweb-theme-config-addon-box">
		<div class="rhweb-theme-config-opener">
			<div class="content">
				<div v-html="$tc('rhweb-theme-config.serviceBox.label.welcomeContent')"></div>

				<div class="signature">
					{{ $tc('rhweb-theme-config.serviceBox.label.welcomeSignature') }}

					<sw-help-text
							class="sw-condition-line-item-in-category__help-text"
							:text="$tc('rhweb-theme-config.serviceBox.label.welcomeHelptext')"
					/>
				</div>
			</div>
		</div>

		<div v-if="!isExtensionActive('RHWebCmsElements')" class="rhweb-theme-config-card-plugins-container">
			<div class="rhweb-theme-config-card-plugin">
				<img :src="getIcon('cms-bundle')">
				<div class="rhweb-theme-config-card-plugin-content">
					<span class="badge">{{ $tc('rhweb-theme-config.serviceBox.addons.cms.badge') }}</span>
					<div class="rhweb-theme-config-card-content">
						<div class="headline"> {{ $tc('rhweb-theme-config.serviceBox.addons.cms.headline') }}</div>
						<p>{{ $tc('rhweb-theme-config.serviceBox.addons.cms.content') }}</p>
						<a v-bind:href="$tc('rhweb-theme-config.serviceBox.addons.cms.buttonUrl')" class="default" target="_blank" rel="noopener">{{ $tc('rhweb-theme-config.serviceBox.addons.cms.button') }}</a>
					</div>
				</div>
			</div>
		</div>

		<div v-if="!isExtensionActive('RHWebThemeFeatures')" class="rhweb-theme-config-card-plugins-container">
			<div class="rhweb-theme-config-card-plugin">
				<img :src="getIcon('theme-features')">
				<div class="rhweb-theme-config-card-plugin-content">
					<span class="badge">{{ $tc('rhweb-theme-config.serviceBox.addons.themefeatures.badge') }}</span>
					<div class="rhweb-theme-config-card-content">
						<div class="headline"> {{ $tc('rhweb-theme-config.serviceBox.addons.themefeatures.headline') }}</div>
						<p>{{ $tc('rhweb-theme-config.serviceBox.addons.themefeatures.content') }}</p>
						<a v-bind:href="$tc('rhweb-theme-config.serviceBox.addons.themefeatures.buttonUrl')" class="default" target="_blank" rel="noopener">{{ $tc('rhweb-theme-config.serviceBox.addons.themefeatures.button') }}</a>
					</div>
				</div>
			</div>
		</div>

		<div class="rhweb-theme-config-card-container">
			<div class="rhweb-theme-config-card">
				<div class="rhweb-theme-config-card-content">
					<div class="headline"> {{ $tc('rhweb-theme-config.serviceBox.two.headline') }}</div>
					<a v-bind:href="$tc('rhweb-theme-config.serviceBox.two.buttonUrl')" class="regular" target="_blank" rel="noopener">{{ $tc('rhweb-theme-config.serviceBox.two.button') }}</a>
				</div>
			</div>
			<div class="rhweb-theme-config-card">
				<div class="rhweb-theme-config-card-content">
					<div class="headline"> {{ $tc('rhweb-theme-config.serviceBox.three.headline') }}</div>
					<a v-bind:href="$tc('rhweb-theme-config.serviceBox.three.buttonUrl')" class="regular" target="_blank">{{ $tc('rhweb-theme-config.serviceBox.three.button') }}</a>
				</div>
			</div>
		</div>
	</div>
	{% parent %}
{% endblock %}


